import * as signalR from "@microsoft/signalr";
import url from "@/services/Url";
import store from "@/store";
import router from "@/router/index";
import { useToast } from "vue-toastification";
const toast = useToast();
import ToastNotificationTicket from "@/components/custom-toast/ToastNotificationTicket.vue";
import ToastNotificationCustom from "@/components/custom-toast/ToastNotificationCustom.vue";
import $bus from "@/utils/event.js";
import utils from "@/utils/index";
import swal from "@/utils/swalAlert";
import { ref } from "vue";
import axiosInstance from "@/services/Api";
import TokenService from "@/services/TokenService";

const mensagemCarregamento = ref({});
const MAX_RECONNECT_ATTEMPTS_BEFORE_LOADING = 3;
const RECONNECT_INTERVAL = 60000;

export const hubConnection = {
  connection: null,
  reconnectAttempts: 0,
  reconnectTimeout: null,
  connecting: false,
  isPublicRoute() {
    return router.currentRoute.value.matched.some(
      (route) => route.meta.public === true
    );
  },
  start() {
    if (this.isPublicRoute()) {
      return;
    }

    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(url + "/appHubPath")
      .build();

    setTimeout(() => {
      this.connect();
    }, 100);
  },

  connect() {
    if (this.connecting) {
      return;
    }

    this.connecting = true;
    this.reconnectAttempts += 1;

    if (this.reconnectAttempts >= MAX_RECONNECT_ATTEMPTS_BEFORE_LOADING) {
      $bus.trigger("exibirLoadingModalGeral", true);
    }

    this.connection.start().then(
      async () => {
        this.connecting = false;
        this.reconnectAttempts = 0;

        // console.log(
        //   "Conectado ao hub SignalR: " + this.connection.connectionId
        // );

        await this.validarSessaoUsuario();

        this.connection.on("DesconectarSessao", () => {
          //console.log("DesconectarSessao: " + this.connection.connectionId);
          this.logoutSessao();
        });

        this.connection.on("DesconectarConnection", () => {
          //console.log("DesconectarConnection: " + this.connection.connectionId);
          this.logoutConnection();
        });

        this.connection.on("NotificacaoTicket", (id_ticket) => {
          //console.log("NotificacaoTicket: " + id_ticket);
          this.exibirNotificacaoTicket(id_ticket);
        });

        this.connection.on("PagamentoAsaas", (evento) => {
          this.exibirNotificacaoPagamentoAsaas(evento);
        });

        this.connection.on("ReceberAsaas", (evento) => {
          this.exibirNotificacaoReceberAsaas(evento);
        });

        this.connection.on("AtualizacaoPlano", (atualizacaoPlano) => {
          this.exibirNotificacaoAtualizacaoPlano(atualizacaoPlano);
        });

        this.connection.on("NovoPedidoMercadoLivre", (pedido) => {
          this.exibirNotificacaoPedidoMercadoLivre(pedido);
        });

        this.connection.on("NFeMercadoLivreEmitida", (evento) => {
          this.exibirNotificacaoNFeMercadoLivre(evento);
        });

        this.connection.on("NFeMercadoLivreFalha", (evento) => {
          this.exibirErroNFeMercadoLivre(evento);
        });

        this.connection.off("GwayAgenteVinculado");
        this.connection.on("GwayAgenteVinculado", (vinculo) => {
          $bus.trigger("gway-agente-vinculado", vinculo);
        });

        this.connection.off("GwayAgenteTrabalhoAtualizado");
        this.connection.on("GwayAgenteTrabalhoAtualizado", (trabalho) => {
          $bus.trigger("gway-agente-trabalho-atualizado", trabalho);
        });

        this.connection.off("GwayAgenteFilaAtualizada");
        this.connection.on("GwayAgenteFilaAtualizada", () => {
          $bus.trigger("gway-agente-fila-atualizada");
        });

        this.connection.on("CarregamentoDados", (mensagem) => {
          mensagemCarregamento.value = mensagem;
        });

        $bus.trigger("exibirLoadingModalGeral", false);
      },
      () => {
        this.connecting = false;
        $bus.trigger("exibirLoadingModalGeral", false);
        this.reconnectTimeout = setTimeout(() => {
          this.reconnectTimeout = null;
          this.connect();
        }, RECONNECT_INTERVAL);
      }
    );

    this.connection.onclose(() => {
      this.connecting = false;
      if (!this.reconnectTimeout) {
        this.reconnectTimeout = setTimeout(() => {
          this.reconnectTimeout = null;
          this.connect();
        }, RECONNECT_INTERVAL);
      }
    });
  },

  async validarSessaoUsuario() {
    if (this.isPublicRoute()) {
      return;
    }

    if (localStorage.getItem("user")) {
      let user = JSON.parse(localStorage.getItem("user"));

      if (
        user.TokenExpires !== null &&
        user.TokenExpires !== undefined &&
        new Date(user.TokenExpires) <= new Date()
      ) {
        try {
          const rs = await axiosInstance.post("/v1/auth/refresh-token/", {
            AccessToken: TokenService.getLocalAccessToken(),
            RefreshToken: TokenService.getLocalRefreshToken(),
          });

          if (rs.data.Data.Token) {
            TokenService.setUser(rs.data.Data);
            user = JSON.parse(localStorage.getItem("user"));
          }
        } catch (error) {
          console.log(error);
        }
      }

      try {
        let ret = await this.connection.invoke(
          "ConectarUsuario",
          user.RefreshToken,
          user.User.id
        );
        if (ret.success === true) {
          if (
            router &&
            router.currentRoute &&
            router.currentRoute._value &&
            router.currentRoute._value.name &&
            router.currentRoute._value.name.includes("sign-in")
          ) {
            router.push("/" + utils.getWL() + "/dashboard");
          }
        } else {
          if (
            !(
              router &&
              router.currentRoute &&
              router.currentRoute._value &&
              router.currentRoute._value.name &&
              (router.currentRoute._value.name.includes("sign-in") ||
                router.currentRoute._value.name.includes("404"))
            )
          ) {
            await swal.showInvalidAlert(ret.message, (alert) => {
              this.logoutConnection();
            });
          }
        }
      } catch (error) {
        await swal.showErrorAlert(error.message, (alert) => {
          this.logoutConnection();
        });
      }
    } else {
      if (
        !(
          router &&
          router.currentRoute &&
          router.currentRoute._value &&
          router.currentRoute._value.name &&
          (router.currentRoute._value.name.includes("register") ||
            router.currentRoute._value.name.includes("password-reset"))
        )
      ) {
        router.push("/" + utils.getWL() + "/sign-in");
      }
    }
  },

  logoutSessao() {
    if (this.isPublicRoute()) {
      return;
    }

    store.dispatch("auth/logout").then(() => {
      router.push("/" + utils.getWL() + "/sign-in");
      toast.info("Sessão expirada, por favor faça login novamente!", {
        timeout: 3000,
      });
    });
  },

  logoutConnection() {
    if (this.isPublicRoute()) {
      return;
    }

    router.push("/" + utils.getWL() + "/sign-in");
    toast.info("Sessão expirada, por favor faça login novamente!", {
      timeout: 3000,
    });
  },

  exibirNotificacaoTicket(id_ticket) {
    toast.info(
      {
        component: ToastNotificationTicket,
        listeners: {
          abrirTicket: () => {
            if (
              router &&
              router.currentRoute &&
              router.currentRoute._value &&
              router.currentRoute._value.path &&
              router.currentRoute._value.path.includes(
                "/suporte/ticket/editar/" + id_ticket.toString()
              )
            ) {
              $bus.trigger("atualizar-ticket");
            } else {
              router.push(
                "/" +
                  utils.getWL() +
                  "/suporte/ticket/editar/" +
                  id_ticket.toString()
              );
            }
          },
        },
      },
      {
        timeout: false,
      }
    );
  },

  exibirNotificacaoPagamentoAsaas(evento) {
    if (localStorage.getItem("user")) {
      let user = JSON.parse(localStorage.getItem("user"));
      let rota = "";
      if (
        user.User.TipoUsuario.tipo === "Administrador" ||
        user.User.TipoUsuario.tipo === "Distribuidor Master" ||
        user.User.TipoUsuario.tipo === "Distribuidor" ||
        user.User.TipoUsuario.tipo === "Revenda"
      ) {
        rota = "/principal/licencarecebivel/consultar";
      } else {
        rota = "/fatura/licenca/consultar";
      }
      let mensagem = `Cobrança Asaas: ${
        evento === "PAYMENT_CONFIRMED"
          ? "Pagamento confirmado"
          : evento === "PAYMENT_RECEIVED"
          ? "Pagamento recebido"
          : evento
      }`;
      if (
        router &&
        router.currentRoute &&
        router.currentRoute._value &&
        router.currentRoute._value.path &&
        router.currentRoute._value.path.includes(rota)
      ) {
        toast.info(mensagem, {
          timeout: 3000,
        });
        $bus.trigger("atualizar-pagamentos-asaas");
      } else {
        toast.info(
          {
            component: ToastNotificationCustom,
            props: {
              mensagem: mensagem,
            },
            listeners: {
              abrirMensagem: () => {
                router.push("/" + utils.getWL() + rota);
              },
            },
          },
          {
            timeout: false,
          }
        );
      }
    }
  },

  exibirNotificacaoReceberAsaas(evento) {
    let mensagem = `Cobrança Asaas: ${
      evento === "PAYMENT_CONFIRMED"
        ? "Pagamento confirmado"
        : evento === "PAYMENT_RECEIVED"
        ? "Pagamento recebido"
        : evento
    }`;
    if (
      router &&
      router.currentRoute &&
      router.currentRoute._value &&
      router.currentRoute._value.path &&
      router.currentRoute._value.path.includes("/financeiro/receber/consultar")
    ) {
      toast.info(mensagem, {
        timeout: 3000,
      });
      $bus.trigger("atualizar-receber-asaas");
    } else {
      toast.info(
        {
          component: ToastNotificationCustom,
          props: {
            mensagem: mensagem,
          },
          listeners: {
            abrirMensagem: () => {
              router.push(
                "/" + utils.getWL() + "/financeiro/receber/consultar"
              );
            },
          },
        },
        {
          timeout: false,
        }
      );
    }
  },

  async exibirNotificacaoAtualizacaoPlano(atualizacaoPlano) {
    let mensagem = `Parabéns você acaba de obter acesso ao plano: ${
      utils.retornarPlano(atualizacaoPlano.tipo_pacote_solicitado).titulo
    } da ${utils.getNomeEmpresaWL()}! Faça login novamente para aproveitar os novos recursos disponíveis!`;
    await swal.showInfoAlert(mensagem, (alert) => {
      this.logoutSessao();
    });
  },
  exibirNotificacaoPedidoMercadoLivre(pedido) {
    const orderId = pedido?.mercado_livre_order_id || pedido?.id_pedido || "";
    const comprador = pedido?.comprador ? ` para ${pedido.comprador}` : "";
    const mensagem = `Novo pedido do Mercado Livre${comprador}. Pedido ML ${orderId}.`;

    toast.info(mensagem, {
      timeout: 5000,
    });

    $bus.trigger("atualizar-pedidos-mercadolivre", pedido);
  },
  exibirNotificacaoNFeMercadoLivre(evento) {
    const numeroNota =
      evento?.nota && evento?.serie
        ? `${evento.nota}/${evento.serie}`
        : "gerada automaticamente";
    const mensagem = `NF-e ${numeroNota} emitida para o pedido do Mercado Livre ${
      evento?.mercado_livre_order_id || evento?.id_pedido || ""
    }.`;

    toast.info(
      {
        component: ToastNotificationCustom,
        props: {
          mensagem: mensagem,
        },
        listeners: {
          abrirMensagem: () => {
            router.push(
              "/" + utils.getWL() + "/movimentacao/faturamento/consultar"
            );
          },
        },
      },
      {
        timeout: false,
      }
    );

    $bus.trigger("atualizar-pedidos-mercadolivre", evento);
  },
  exibirErroNFeMercadoLivre(evento) {
    const mensagem = `Falha ao emitir automaticamente a NF-e do pedido do Mercado Livre ${
      evento?.id_pedido || ""
    }: ${evento?.mensagem || "verifique as configurações fiscais."}`;

    toast.error(
      {
        component: ToastNotificationCustom,
        props: {
          mensagem: mensagem,
        },
        listeners: {
          abrirMensagem: () => {
            router.push(
              "/" + utils.getWL() + "/movimentacao/pedidos/consultar"
            );
          },
        },
      },
      {
        timeout: false,
      }
    );
  },
};

export { mensagemCarregamento };
export default hubConnection;
